module.exports = __webpack_public_path__ + "assets/RedoBtn.d832d7b095a342ccc194b0f7e40a515e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/RedoBtn.svg
// module id = 869
// module chunks = 0